import { VIANUVEM_API_ENDPOINT } from "./Defaults";

export const userCpfValidation = data => {
    return new Promise((resolve, reject) => {
        fetch(`${VIANUVEM_API_ENDPOINT}/public/users/cpf/validate/${data.cpf}/${data.token}`)
            .then(response => response.text())
            .then(response => {
                if (response === 'true') {
                    resolve('');
                } else {
                    reject('Cpf inválido ou já cadastrado');
                }
            })
            .catch(reject)
    });
};

export const passwordConfirmation = ({password, confirmation}) => {
    return new Promise((resolve, reject) => {
        if (password === confirmation) {
            resolve(true);
        }

        reject('As senhas não conferem');
    });
}

export const userPasswordValidation = {
    init: function(password){
        const that = userPasswordValidation;
        password = password || "";
        return new Promise((resolve, reject) => {
            try {
                let errors = [];
                const rulesLength = that.rules.length;

                that.rules.forEach((rule) => {
                    const isOk = rule.method(password);
                    if (!isOk) {
                        errors.push({message: rule.msg});
                    }
                });

                const power = 100 - (errors.length / rulesLength * 100);
                let status = 'exception';

                if (power > 50 && power < 100) {
                    status = 'success';
                } else if (power === 100) {
                    status = 'active';
                }

                resolve({
                    power,
                    status,
                    message: errors.length ? errors[0].message : 'A senha é válida.'
                });
            } catch (e) {
                reject(e);
            }
        })
    },
    rules: [
        {
            id: 1,
            msg: 'A senha deve conter pelo menos um caractere especial (ex. @#!%.).',
            method: function(pass){
                return /[~`!@.#$%^&*+=\-[\]\\';,/{}|\\":<>?]/g.test(pass);
            }
        },
        {
            id: 2,
            msg: 'A senha deve conter pelo menos seis caracteres.',
            method: function(pass){
                return pass.length >= 5;
            }
        },
        {
            id: 3,
            msg: 'A senha deve conter pelo menos um número.',
            method: function(pass){
                return /[0-9]/g.test(pass);
            }
        },
        {
            id: 4,
            msg: 'A senha deve conter pelo menos uma letra.',
            method: function(pass){
                return /[A-z]/g.test(pass);
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/integrations/InputValidationsAPI.js